import {CartForm} from "./cart_form";
import {formatMoney} from '@shopify/theme-currency';

// const bundleItems = [39289611223155, 39287756390515];

// example array for bundles

/**
 * bundles_array = [
 {
      bundle_name: 'Face Bottle Bundle',
      bundle_class: 'Face_Bottle_Bundle',
    
      bundle_percentage: 50,
      bundle_components: [39289611223155,6553685622899]
    },
 {
      bundle_name: 'Face Bottle Oil Mini1 Bundle',
      bundle_class: 'Face_Bottle_Oil_Mini1_Bundle',
      bundle_percentage: 75,
      bundle_components: [39289611223155,6553685622899,39289616302195,39289611124851]
    },
 */

export class CartPage {
    constructor(cart, body, api) {
        this.cart = cart;
        this.api = api;
        body.find('.v4-cart-form')
            .each(function () {
                new CartForm(cart, jQuery(this), api);
            });
    }

}